import React from "react"

const LazyRouteLoader = () => (
  <div className="lazy-route-loading" aria-live="polite" aria-busy="true">
    <div className="lazy-route-loading__overlay" aria-hidden="true" />
    <div className="lazy-route-loading__spinner" aria-hidden="true" />
  </div>
)

export default LazyRouteLoader
